import gql from 'graphql-tag';

export const updateClaim = gql`
  mutation updateClaim($input: UpdateClaimInput) {
    updateClaim(input: $input) {
      id
      name
      roles {
        id
        name
      }
    }
  }
`;
